'use strict';

var $ = require('../internals/export');

var createHTML = require('../internals/create-html');

var forcedStringHTMLMethod = require('../internals/forced-string-html-method'); // `String.prototype.strike` method
// https://tc39.github.io/ecma262/#sec-string.prototype.strike


$({
  target: 'String',
  proto: true,
  forced: forcedStringHTMLMethod('strike')
}, {
  strike: function strike() {
    return createHTML(this, 'strike', '', '');
  }
});